import { useTranslation } from 'react-i18next';
import {
  useGetEmailRule,
  useGetFacebookRule,
  useGetPhoneRule,
  useGetRequiredRule,
  useGetUrlRule,
  useGetInstagramRule,
  useGetTwitterRule,
  useGetTiktokRule,
  useGetYoutubeRule,
  useLengthValidationRule,
  useGetNumbersOnlyRule,
} from '@/hooks';
import { TFormValidatorRule } from '@/types';
import { SettingsFormFields } from '../helpers/types';

export const useSettingsFormRules = () => {
  const { t } = useTranslation(['validations', 'settings']);

  const requiredRule = useGetRequiredRule({ t });
  const urlRule = useGetUrlRule({ t });
  const emailRule = useGetEmailRule({ t });
  const phoneRule = useGetPhoneRule({ t });
  const facebookRule = useGetFacebookRule({ t });
  const instagramRule = useGetInstagramRule({ t });
  const twitterRule = useGetTwitterRule({ t });
  const tiktokRule = useGetTiktokRule({ t });
  const youtubeRule = useGetYoutubeRule({ t });
  const descriptionFieldLength = useLengthValidationRule({ t, max: 255 });
  const numbersOnlyRule = useGetNumbersOnlyRule({ t });

  return {
    [SettingsFormFields.ADDRESS]: [requiredRule],
    [SettingsFormFields.FOP_ID]: [requiredRule, numbersOnlyRule],
    [SettingsFormFields.FOP_DESCRIPTION]: [requiredRule, descriptionFieldLength],
    [SettingsFormFields.CONTACT_EMAIL]: [requiredRule, emailRule],
    [SettingsFormFields.CONTACT_PHONE]: [requiredRule, phoneRule],
    [SettingsFormFields.WORKING_HOURS]: [requiredRule],
    [SettingsFormFields.GOOGLE_ANALYTICS]: [],
    [SettingsFormFields.ADMIN_EMAILS]: [requiredRule],
    [SettingsFormFields.ORDER_EMAILS]: [requiredRule],
    [SettingsFormFields.PRICE_CHANGE_ADMIN_EMAILS]: [requiredRule],
    [SettingsFormFields.FACEBOOK]: [facebookRule],
    [SettingsFormFields.INSTAGRAM]: [instagramRule],
    [SettingsFormFields.TWITTER]: [twitterRule],
    [SettingsFormFields.THREADS]: [urlRule],
    [SettingsFormFields.TIK_TOK]: [tiktokRule],
    [SettingsFormFields.YOUTUBE]: [youtubeRule],
    [SettingsFormFields.VIBER]: [urlRule],
    [SettingsFormFields.TELEGRAM]: [urlRule],
    [SettingsFormFields.MIN_ORDER_TOTAL]: [
      requiredRule,
      {
        type: 'number',
        min: 0.01,
        message: t('min_order_total_invalid', { ns: 'settings' }),
      } as TFormValidatorRule,
    ],
    [SettingsFormFields.FOP_CASH_REGISTER_ID]: [],
    [SettingsFormFields.TOV_CASH_REGISTER_ID]: [],
    [SettingsFormFields.FOP_CASHIER_NAME]: [],
    [SettingsFormFields.TOV_CASHIER_NAME]: [],
    [SettingsFormFields.FOP_FISCAL_DEPARTMENT]: [],
    [SettingsFormFields.TOV_FISCAL_DEPARTMENT]: [],
  };
};
